import { defineMessages } from 'react-intl';

export const mcpPermissionsMessages = defineMessages({
  sectionTitle: {
    id: 'oauth.mcp.permissions.sectionTitle',
    defaultMessage: 'Permissions',
    description: 'Section heading for MCP permissions',
  },
  irreversibleResults: {
    id: 'oauth.mcp.permissions.irreversibleResults',
    defaultMessage: 'Irreversible results',
    description:
      'Badge on the Delete permission group whose actions cannot be undone',
  },
  worksAcrossOrganization: {
    id: 'oauth.mcp.permissions.worksAcrossOrganization',
    defaultMessage: 'Works across organization',
    description:
      'Badge on a toolset whose results/actions range across the whole organization rather than a single resource',
  },
  worksAcrossUnit: {
    id: 'oauth.mcp.permissions.worksAcrossUnit',
    defaultMessage: 'Works across unit',
    description:
      'Badge on a toolset whose results/actions range across every connected app in the collaboration unit rather than a single site',
  },
  toolsetsSelected: {
    id: 'oauth.mcp.permissions.toolsetsSelected',
    defaultMessage: '{selected} out of {total} permissions selected',
    description:
      'Counter shown in footer when editing permissions; {selected} and {total} are numbers',
  },
  emptyStateHeading: {
    id: 'oauth.mcp.permissions.emptyStateHeading',
    defaultMessage: 'Permissions are blocked for this {productUnit}',
    description:
      'Heading when the workspace policy returns no permission toolsets; {productUnit} is "Trello workspace" or "Atlassian site"',
  },
  emptyStateHeadingMultiple: {
    id: 'oauth.mcp.permissions.emptyStateHeadingMultiple',
    defaultMessage: 'Permissions are blocked for these workspaces',
    description:
      'Heading when the workspace policy returns no permission toolsets for a multi-workspace Trello selection',
  },
  emptyStateDescription: {
    id: 'oauth.mcp.permissions.emptyStateDescription',
    defaultMessage:
      'Contact your organization admin to request access or see <howPermissionsLink>how permissions are managed</howPermissionsLink>',
    description:
      'Body copy for blocked permissions empty state, with embedded link to documentation about MCP permission management',
  },
});

export const mcpBannerMessages = defineMessages({
  editWarningTitle: {
    id: 'oauth.mcp.banner.editWarning.title',
    defaultMessage: 'Unselected permissions will limit {product} MCP features',
    description:
      'Warning banner title when the user has deselected one or more MCP permission toolsets; {product} is either "Atlassian" or "Trello"',
  },
  editWarningBody: {
    id: 'oauth.mcp.banner.editWarning.body',
    defaultMessage:
      "If you later want to use a feature that requires a permission you didn't grant, you'll need to disconnect and reconnect {product} MCP to update your permissions.",
    description:
      'Warning banner body when the user has deselected one or more MCP permission toolsets; {product} is either "Atlassian" or "Trello"',
  },
  editWarningDismiss: {
    id: 'oauth.mcp.banner.editWarning.dismiss',
    defaultMessage: 'Understood',
    description:
      'Dismiss button label on the warning banner when the user has deselected MCP permission toolsets',
  },
  inboxPlannerDisabledMessage: {
    id: 'oauth.mcp.banner.inboxPlannerDisabled.message',
    defaultMessage:
      'Inbox and Planner permissions are disabled since this workspace is not owned by your organisation. Permission for this workspace and its boards can still proceed.',
    description:
      "Info banner shown when inbox/planner scopes are excluded because the selected Trello workspace is outside the user's managing organization",
  },
  noWorkspacesInboxPlannerMessage: {
    id: 'oauth.mcp.banner.noWorkspacesInboxPlanner.message',
    defaultMessage:
      "You don't have any Trello workspaces, but you can still connect your Inbox and Planner. Boards, cards, and lists won't be available until you join or create a workspace.",
    description:
      'Info banner shown when the user has no Trello workspaces but the requested scopes still allow connecting Inbox and Planner',
  },
  inboxPlannerDisabledMultipleMessage: {
    id: 'oauth.mcp.banner.inboxPlannerDisabledMultiple.message',
    defaultMessage:
      'Inbox and Planner permissions are disabled for some workspaces since they are not owned by your organisation. Permissions for their boards can still proceed.',
    description:
      "Info banner shown when inbox/planner scopes are excluded because more than one of the selected Trello workspaces is outside the user's managing organization",
  },
});
